const Logo = () => {
    return <img src="/Climate-AI-Color-Logo.png" className="max-w-[200px] h-auto" />
}

export default Logo
